import { Button, Tooltip, Typography } from "@pankod/refine-antd";
import { useNavigation } from "@pankod/refine-core";
import { LookupProps } from "./lookupButton";

export declare type RenderLinkProps = LookupProps & {
    name: string | undefined;
    clickable?: boolean;
};

export const RenderLink: React.FC<RenderLinkProps> = ({
    id,
    resource,
    name,
    clickable = false,
    ...rest
}) => {
    const { show } = useNavigation();

    return (
        id !== "" && resource !== ""
            ? (
                name ?
                    <Button
                        type="link"
                        size="small"
                        style={{ padding: 0 }}
                        {...rest}
                        onClick={(e) => {
                            if(clickable) {
                                show(resource, id);
                            }
                            e.stopPropagation();
                        }}
                    >
                        <Tooltip title={id}>
                            {name ?? id}
                        </Tooltip>
                    </Button>
                    : <Typography.Text>{id}</Typography.Text>)
            : <>---</>
    );
};